import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-grid-edit',
  templateUrl: './grid-edit.component.html',
  styleUrls: ['./grid-edit.component.css']
})
export class GridEditComponent implements OnInit {
  columns: any[];
  dataSource: any[];
  tabDataSource = [
    { id: { }, title: 'List' }
  ];
  tabSelectedIndex = 0;

  @Input() useToolbar = true;
  @Input() allowAdding = true;
  @Input() allowUpdating = true;
  @Input() allowDeleting = true;

  @Output() refresh = new EventEmitter<void>();
  @Output() selectedDetail = new EventEmitter<any>();
  @Output() showDetail = new EventEmitter<boolean>();
  @Output() rowInserting = new EventEmitter<any>();
  @Output() rowUpdating = new EventEmitter<any>();
  @Output() rowRemoving = new EventEmitter<any>();
  @Output() initNewRow = new EventEmitter<any>();

  @ViewChild(DxDataGridComponent) private dxgrid: DxDataGridComponent;

  constructor() { }

  ngOnInit() {
  }

  @Input()
  set gridColumns(cols: any[]) {
    this.columns = cols;
  }

  @Input()
  set gridRecords(recs: any[]) {
    this.dataSource = recs;
  }

  onRefresh() {
    this.refresh.emit();
  }

  onAdd() {
    this.dxgrid.instance.addRow();
  }

  onCloseTab() {
    this.tabDataSource.splice(this.tabSelectedIndex, 1);

    let tabIdx = this.tabDataSource.length - 1;
    if (tabIdx > 0) {
      this.tabSelectedIndex = this.tabDataSource.length - 1;
      this.showDetail.emit(true);
      this.selectedDetail.emit(this.tabDataSource[this.tabSelectedIndex].id);
    } else {
      this.tabSelectedIndex = 0;
      this.showDetail.emit(false);
    }
  }

  onTitleClick(e) {
    this.tabSelectedIndex = e.itemIndex;
    this.showDetail.emit(this.tabSelectedIndex !== 0);
    this.selectedDetail.emit(this.tabDataSource[e.itemIndex].id);
  }

  onTabTemplateClick(data: any) {
    for (let i = 0; i < this.tabDataSource.length; i++) {
      let tab = this.tabDataSource[i];
      if (data === tab.id) {
        return;
      }
    }
    if (data.Code !== undefined) {
      this.tabDataSource.push({ id: data, title: data.Code });
    } else {
      this.tabDataSource.push({ id: data, title: data.Name || data.title || 'No title found' });
    }
  }

  onCellClick(e) {
    if (e.column.dataField !== undefined && !e.row.isEditing) {
      this.selectedDetail.emit(e.key);
      for (let i = 0; i < this.tabDataSource.length; i++) {
        let tab = this.tabDataSource[i];
        if (e.key === tab.id) {
          this.tabSelectedIndex = i;
          this.showDetail.emit(true);
          return;
        }
      }
      if (e.key.TabTitle !== undefined) {
        this.tabDataSource.push({ id: e.key, title: e.key.TabTitle });
      }
      else if (e.key.Code !== undefined) {
        this.tabDataSource.push({ id: e.key, title: e.key.Code });
      } else {
        this.tabDataSource.push({ id: e.key, title: e.key.Name || e.key.title || 'No title found' });
      }
      this.tabSelectedIndex = this.tabDataSource.length - 1;
      this.showDetail.emit(true);
    }
  }

  onRowInserting(e) {
    this.rowInserting.emit(e.data);
  }

  onRowUpdating(e) {
    this.rowUpdating.emit(Object.assign(e.oldData, e.newData));
  }

  onRowRemoving(e) {
    this.rowRemoving.emit(e.data);
  }

  onInitNewRow(e) {
    this.initNewRow.emit(e);
  }

}
